import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { ContentBuilderColorPipe } from '@core/pipes/content-builder-color.pipe';
import { PriceAtomComponent } from '@shared/atoms/price-atom/price-atom.component';

@Component({
  selector: 'app-overview-cart-additional-atom',
  templateUrl: './overview-cart-additional-atom.component.html',
  standalone: true,
  imports: [ContentBuilderColorPipe, TranslateModule, PriceAtomComponent],
})
export class OverviewCartAdditionalAtomComponent {
  @Input() text!: string;
  @Input() icon!: string;
  @Input() price!: number;
  @Input() mustTranslate: boolean = false;
  @Input() textColor: IContentBuilderFieldColor = {
    value: 'neutral-800',
    type: ColorFieldTypesValues.Palette,
  };
  @Input() secondaryTextColor: IContentBuilderFieldColor = {
    value: 'neutral-500',
    type: ColorFieldTypesValues.Palette,
  };
}
